import React, { useState, useEffect, useContext } from 'react';
import AppContext from "../AppContext"
import {
    Form,
    Select,
    Badge,
    Input,
    Button,
    List,
    Card,
    message,
    Modal,
    Table,
    Space,
    Divider,
    Row,
    Col,
    Tag,
    InputNumber,
    Checkbox
} from "antd";
import { UserStatus as UserStatusObj, USR_STATUS, CompanyId as CompanyIdObj } from '../../Models/shared/master';
import { ReloadOutlined, PlusCircleTwoTone } from "@ant-design/icons"
import { onGetUser, onCreateUser, UserUpdatebyId, getAllUserLists } from "../../Controller/Management/UserProf_Ctrl"
import { onGetShift } from '../../Controller/Management/ShiftManagement';
import { onGetDepartment } from '../../Controller/Management/DepartmentManagement';
// import { PermissionGetbyID } from "../../Controller/Management/Permission_Controller"
import "../../css/gradientTxT.css"
const { Meta } = Card;
const { Option } = Select;

export default function UserProfList(prop) {

    const dbProps = {
        userid: 'userid',
        password: 'password',
        parentid: 'parentid',
        companyid: 'companyid',
        type: 'type',
        permid: 'permid',
        report: "reportto",
        secret: 'secret',
        timezone: 'timezone',
        status: 'status',
        allowedgames: 'allowedgames',
        markingcode: "markingcode",
        isapiuser: "isapiuser",
        // department          : "department",
        shift: "shift",
        isWFH: "iswfh",
        department: "department",
        grouping: "grouping",
        telegramid: "telegramid"
        // hasOT               : "hasot",
        // worktime            : "worktime",
        // startworktime       : "startworktime",
        // duration            : "duration",
        // minimumOTduration   : "minimumot",
    }
    /**
     * LUCAS: Below be useState Hooks, 
     * look into internet about "Reactjs Usestate Hook" for more info
     */
    const [permissionObj, setPermissionObj] = useState({});
    const [userData, setUserData] = useState({})
    const [userList, setUserList] = useState([]);
    const [userprofform] = Form.useForm();
    const [shiftList, setShiftList] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [reportingList, setReportingList] = useState([])
    const [isModalVisible, setIsModalVisible] = useState("");
    const [modalTitle, setModalTitle] = useState("");
    const [modalAction, setModalAction] = useState("");
    const [loading, setLoading] = useState(false);
    const [action, setAction] = useState("");

    /**
     * LUCAS: UseContext is like global variable, it's located in outest
     * layer of code
     */
    const global = useContext(AppContext)

    /**
     * Below be the table/list header
     */
    const columns = [
        {
            title: 'User ID',
            dataIndex: dbProps.userid,
            key: 'userid'
        },
        {
            title: 'Contact Name',
            dataIndex: dbProps.markingcode,
            key: 'markingcode'
        },
        {
            title: 'Parent ID',
            key: 'parentid',
            render: (record) => {
                return (
                    <>
                        {CompanyIdObj[record[dbProps.companyid]]
                        }
                    </>
                )
            },

        },
        {
            title: 'Permission',
            key: 'permname',
            render: (record) =>
                permissionObj[record[dbProps.permid]]

        },
        {
            title: 'Reporting to',
            dataIndex: dbProps.report,
            key: 'status'
        },
        {
            title: 'Status',
            render: (record) => {
                return (
                    <>
                        {UserStatusObj[record[dbProps.status]]
                        }
                    </>
                )
            },

            key: 'status'
        },
        {
            title: 'Action',
            key: 'Action',
            fixed: "right",
            render: (record) => {
                return (
                    <>
                        <Space>
                            <Button
                                onClick={() => onEditUser(record)}>Edit</Button>
                        </Space>
                    </>
                )
            }
        }

    ]

    useEffect(() => {
        init();
    }, []);


    async function init() {
        setLoading(true)
        // const result = await onGetUser({});
        return Promise.all([onGetUser({}), onGetShift({}), onGetDepartment({})])
            .then(([val, val2, val3]) => {
                message.loading("Retrieving user data").then(async () => {
                    if (val && val.data && val.data.length) {
                        setUserList(val.data);
                        setShiftList(val2.data);
                        setDepartmentList(val3.data);
                        // console.log('RESULT DATA >>> ', result.data);
                        message.loading("Mapping user details").then(async () => {
                            const reportusr = await getReportingUsers();
                            // const permList = await getPermissionList()
                            if (reportusr && reportusr.data && reportusr.data.length) {
                                setReportingList(reportusr.data)
                            }
                            else {
                                message.warning("Reporting To no available")
                                setReportingList([])
                            }
                            // if (permList && permList.data) {
                            //     setPermissionObj(permList.data)
                            // }
                            // else {
                            //     message.warning("No permission found")
                            //     setPermissionObj({})
                            // }
                            setLoading(false)
                        })
                    }
                    else {
                        setLoading(false)
                        message.error("Failed to retrieve user.")
                        setUserList([]);
                    }
                })
            })
            .catch(err => {
                message.error("Failed to load data");
            })
    };

    async function getReportingUsers() {
        const result = await getAllUserLists({ "userid": global.UserIdentity.userid });
        return result

    }

    // async function getPermissionList() {
    //     const result = await PermissionGetbyID({ "userid": global.UserIdentity.userid })
    //     return result

    // }

    const CreateUser = () => {
        showModal('createuser');
    };

    const onEditUser = (record) => {
        record.worktime = parseFloat(record.startworktime) / 3600 || "";   //20210817 start work time with base 10

        setUserData(record)
        showModal('edituser');
    };

    const showModal = (modalAction) => {
        setModalAction(modalAction);
        switch (modalAction) {
            case "createuser":
                setAction("create");
                setModalTitle(`New User`);
                setIsModalVisible(true);
                break;
            case "edituser":
                setAction("edit");
                setModalTitle("Edit User");
                setIsModalVisible(true);
                break;
            case "deleteuser":
                setAction("delete");
                setModalTitle("Delete User");
                setIsModalVisible(true);
                break;
            default:
                message.error("No Action required");
                break;
        }

    };

    const handleCancel = () => {
        userprofform.resetFields()
        setAction("")
        setUserData({})
        setIsModalVisible(false);
    };

    const handleOk = async () => {
        userprofform.submit()
    };

    const onRefresh = () => {
        userprofform.resetFields()
        setUserData({})
        //=====REFRESH =======
        init();
    };

    const onFinish = async (data) => {
        console.log('DATA >>> ', data);
        let result;
        switch (action) {
            case 'create':
                result = await onCreateUser(data);
                break;
            case 'edit':
                result = await UserUpdatebyId(data)
                break;
            default:
                message.error("unknown operation, check your interface and try again");
                setIsModalVisible(false);
                return;
        }

        if (result && result.status === "ok") {
            message.success(result.msg);
            onRefresh();
            setIsModalVisible(false);
        }
        else {
            message.error(result.msg);
            onRefresh();
            setIsModalVisible(false);
        }

    };

    //========== MODAL FORM ==========
    const userProfModal = () => {
        return (
            <Modal
                title={modalTitle}
                visible={isModalVisible}
                destroyOnClose={true}
                style={{
                    maxWidth: "80%",
                }}
                bodyStyle={{
                    overflow: "auto",
                    maxHeight: "70vh"
                }}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="Submit">

                {
                    modalAction !== 'testing' && action !== 'delete' ?
                        (
                            <UserProfForm />
                        ) :
                        modalAction === 'testing' ?
                            (
                                <UserProfForm />
                            ) :
                            action === 'delete' ?
                                (
                                    <div>Are you sure you want to remove??</div>
                                ) :
                                (
                                    <></>
                                )
                }
            </Modal>
        )

    };

    const UserProfForm = () => {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 14 },
            },
        };
        //const UserStatusData = Object.keys(UserStatusObj).map((key) => [UserStatusObj[key]]);
        //const UserStatusOptions = UserStatusData.map(UserStatus => <Option key={UserStatus}>{UserStatus}</Option>);

        var UserStatusData = Object.values(UserStatusObj).map((value, index) => [Object.keys(UserStatusObj)[index], value]);

        const UserStatusOptions = UserStatusData.map(UserStatus => {
            return (
                <Option value={parseInt(UserStatus[0])} >{UserStatus[1]}</Option>
            )
        });
        const userLists = action === "edit" ? reportingList.filter(x => {
            if (x[dbProps.userid] !== userData[dbProps.userid]) {
                return x
            }
        }) : reportingList
        var PermissionData = Object.values(permissionObj).map((value, index) => [Object.keys(permissionObj)[index], value]);
        var ReportingList = userLists.map(user => {
            return (
                <Option key={user[dbProps.userid]} value={user[dbProps.userid]}>{user[dbProps.markingcode]}</Option>
            )
        })


        var PermissionOptions = PermissionData.map(Permission => {
            return (
                <Option key={Permission[0]} value={Permission[0]} >{Permission[1]}</Option>
            )
        })

        var CompanyIdData = Object.values(CompanyIdObj).map((value, index) => [Object.keys(CompanyIdObj)[index], value]);

        const CompanyIdOptions = CompanyIdData.map(CompanyId => {
            return (
                <Option value={CompanyId[1]} >{CompanyId[1]}</Option>
            )
        });

        //==== SHIFT =======
        const ShiftOptions = shiftList.map(Shift => {
            return (
                <Option value={Shift._id}>{Shift.name}</Option>
            )
        })

        const DepartmentOptions = departmentList.map(Department => {
            return (
                <Option value={Department._id}>{Department.name}</Option>
            )
        })



        useEffect(() => {

            if (action === "edit") {
                userprofform.setFieldsValue(userData)
            }
            else {
                userprofform.setFieldsValue({ permid: userData["permid"] ? userData["permid"].toString() : "", parentid: global.UserIdentity.userid, companyid: global.UserIdentity.userid })
            }
        }, []);
        return (
            <>

                <div>
                    <Form
                        form={userprofform}
                        onFinish={onFinish}
                    >
                        {action === 'create' ? (
                            <Form.Item name={dbProps.userid} label="User ID" rules={[{ required: true, message: "User ID is required" }]}
                                {...formItemLayout}>
                                <Input placeholder="User ID" />
                            </Form.Item>
                        ) :
                            (<></>
                            )
                        }
                        {

                            action === "edit" ? (<>
                                <Form.Item noStyle name={dbProps.userid} rules={[{ required: true }]}>
                                </Form.Item>
                            </>) : null
                        }


                        <Form.Item name={dbProps.password} label="Password" rules={[{ required: true, message: "Password is required" }]}
                            {...formItemLayout}>
                            <Input placeholder="Password"
                            // onChange={(e) => { setUserPass(e.target.value) }}
                            />
                        </Form.Item>
                        <Form.Item name={dbProps.markingcode} label="Contact Name" rules={[{ required: false, message: "Contact Name is required" }, { max: 20, message: 'No more than 20 characters' }]}
                            {...formItemLayout}>
                            <Input placeholder="Contact Name" />
                        </Form.Item>

                        <Form.Item name={dbProps.companyid} label="Company ID"
                            {...formItemLayout}>
                            <Select placeholder="Select Company">
                                {CompanyIdOptions}
                            </Select>
                        </Form.Item>

                        <Form.Item name={dbProps.parentid} label="Parent ID"
                            {...formItemLayout}>
                            <Input placeholder="Parent ID" />
                        </Form.Item>
                        <Form.Item name={dbProps.report} label="Reporting to"
                            rules={[{ required: false, message: "Please choose someone!" }]}
                            {...formItemLayout}>
                            <Select placeholder="Select a user">
                                {ReportingList}
                            </Select>
                        </Form.Item>
                        <Form.Item name={dbProps.permid} label="Permission"
                            rules={[{ required: false, message: "Permission is required" }]}
                            {...formItemLayout}>
                            <Select placeholder="Select Permission">
                                {PermissionOptions}
                            </Select>
                        </Form.Item>

                        <Form.Item name={dbProps.status} label="Status" rules={[{ required: false, message: "Status is required" }]}
                            {...formItemLayout}>
                            <Select placeholder="Select Status">
                                {UserStatusOptions}
                            </Select>
                        </Form.Item>
                        {/* 20210812 -DEPARTMENT */}
                        {/* <Form.Item name={dbProps.department} label="Department" rules={[{ required: false, message: "Department is required" }]}
                            {...formItemLayout}>
                            <Select placeholder="Select Department">
                                <Option value="programmer">Programmer</Option>
                                <Option value="cs">Customer Support</Option>
                                <Option value="sales">Sales and Marketing</Option>
                            </Select>
                        </Form.Item> */}
                        {/* 20210812 - SHIFT */}
                        <Form.Item name={dbProps.shift} label="Shift" rules={[{ required: false, message: "Shift is required" }]}
                            {...formItemLayout}>
                            <Select placeholder="Select Shift">
                                {ShiftOptions}
                            </Select>
                        </Form.Item>
                        {/* 20220411 - DEPARTMENT */}
                        <Form.Item name={dbProps.department} label="Department" rules={[{ required: false, message: "Department is required" }]}
                            {...formItemLayout}>
                            <Select placeholder="Select Department">
                                {DepartmentOptions}
                            </Select>
                        </Form.Item>
                        {/* 20250213 - TELEGRAM */}
                        <Form.Item name={dbProps.telegramid} label="Telegram" rules={[{ required: false, message: "Telegram ID is required" }]}
                            {...formItemLayout}>
                            <Input placeholder="Telegram" />
                        </Form.Item>
                        {/* 20210813 - Can WFH */}
                        <Form.Item name={dbProps.isWFH} valuePropName="checked" label="Is WFH" rules={[{ required: false, message: "Is WFH is required" }]}
                            {...formItemLayout}>
                            <Checkbox />
                        </Form.Item>
                        {/* 20220913 - GROUPING */}
                        <Form.Item name={dbProps.grouping} label="Grouping" rules={[{ required: false, message: "Grouping is required" }]}
                            {...formItemLayout}>
                            <Select placeholder="Select Grouping">
                                <Option value={"public"}>{"Public"}</Option>
                                <Option value={"private"}>{"Private"}</Option>
                                <Option value={"department"}>{"Within Department"}</Option>
                            </Select>
                        </Form.Item>
                    </Form>
                </div>
            </>
        )
    };


    return (
        <>
            <Row justify="start">
                <Divider>{prop.title ?? "."} <Button icon={<ReloadOutlined />}
                    disabled={loading}
                    onClick={init} /></Divider>
            </Row>
            <Row justify="center" align="middle">
                <Col span={22}>
                    <List
                        loading={loading}
                        grid={{
                            gutter: 16,
                            xs: 2,
                            sm: 2,
                            md: 3,
                            lg: 4,
                            xl: 5,
                            xxl: 6,
                        }}
                        dataSource={[{ "userid": null }, ...userList]}
                        renderItem={data =>
                            <List.Item
                                visible={"false"}
                            >
                                {!data[dbProps.userid] ?
                                    <Card
                                        hoverable
                                        onClick={() => { CreateUser() }}
                                        style={{
                                            borderRadius: "10px",
                                            display: "flex",
                                            minHeight: "100%",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: "4.2em",
                                        }}
                                        description={<small>Create User</small>}
                                    >
                                        <Meta
                                            description={
                                                <>
                                                    <PlusCircleTwoTone twoToneColor={["#00cc00", "rgba(0,0,0,0)"]} />
                                                </>}
                                        />
                                    </Card> :
                                    <Badge.Ribbon
                                        color={USR_STATUS.filter(st => st.key === data[dbProps.status])[0].color}
                                        text={"User is " + USR_STATUS.filter(st => st.key === data[dbProps.status])[0].title}
                                    >
                                        <Card
                                            onClick={() => {
                                                onEditUser(data);
                                                console.log(USR_STATUS.filter(st => st.key.toString() === data[dbProps.status].toString())[0].title)
                                            }}
                                            hoverable
                                            className="list-card-item-BO"
                                            style={{
                                                minHeight: "100%",
                                                borderRadius: "10px",
                                                textAlign: "center"
                                            }}
                                        >
                                            <Meta
                                                title={
                                                    <font
                                                        className="gradient-text"
                                                        style={{
                                                            fontSize: '2.50em'

                                                        }} size="large">
                                                        {data[dbProps.markingcode]}
                                                    </font>
                                                }
                                                description={<>
                                                    <Row justify="center">
                                                        <Tag color="geekblue">
                                                            {permissionObj[data[dbProps.permid]]}
                                                        </Tag>
                                                    </Row>
                                                    {/* <Divider /> */}
                                                    {/* <Row justify="center">
                                                        <Tag>{data[dbProps.companyid]}</Tag>

                                                    </Row> */}
                                                </>}
                                            />
                                        </Card>
                                    </Badge.Ribbon>
                                }
                            </List.Item>
                        }
                    />
                </Col>
            </Row>
            {userProfModal()}
        </>
    )
}


